export default "__VITE_ASSET__CeCAOvSf__"